module.exports = __webpack_public_path__ + "img/my_account.91318cc2.png";